import axios from "axios";
import { useEffect, useState } from "react";
import AliceCarousel from "react-alice-carousel";
import { Link } from "react-router-dom";
import "react-alice-carousel/lib/alice-carousel.css";


const Carousel = () => {
  const [trending, setTrending] = useState([]);

  const fetchTrendingCoins = async () => {
    const trendingCoinsURL = `https://api.coingecko.com/api/v3/coins/markets?vs_currency=gbp&order=gecko_desc&per_page=20&page=1&sparkline=false&price_change_percentage=24h`
    const { data } = await axios.get(trendingCoinsURL);
    setTrending(data.map((coin: any) => {
      return {
        href: `coin/${coin.id}`,
        ...coin
      }
    }))
  };

  useEffect(() => {
    fetchTrendingCoins();
  }, []);



  const items = trending.map((coin: any) => {
    let profit = coin.price_change_percentage_24h >= 0;

    return (
      <Link style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        cursor: "pointer",
        textTransform: "uppercase",
      }} to={`/coin/${coin.id}`}>
        <span>
          {coin?.symbol}
          &nbsp;
          <span
            style={{
              color: profit ? "rgb(74, 222, 128)" : "rgb(239, 68, 68)",
              fontWeight: 500,
            }}
          >
            {profit && "+"}
            {coin.price_change_percentage_24h?.toFixed(2)}%
          </span>
        </span>
        <span style={{ fontSize: 22, fontWeight: 500 }}>
          £ {coin?.current_price.toFixed(2)}
        </span>
      </Link>
    );
  });

  const responsive = {
    0: {
      items: 2,
    },
    512: {
      items: 4,
    },
  };

  return (
    <div style={{
      height: "50%",
      display: "flex",
      alignItems: "center",
    }}>
      <AliceCarousel
        mouseTracking
        infinite
        autoPlayInterval={1000}
        animationDuration={1500}
        disableDotsControls
        disableButtonsControls
        responsive={responsive}
        items={items}
        autoPlay
      />
    </div>
  );
};

export default Carousel;
